import React from "react";
import imgTransparente from "../imagens/imagem-transparente.png";
import "./Home.css";
import Contato from "./Componentes/Formulario.js"
import Randa from "../imagens/clientes/Randa.png";
import Klabin from "../imagens/clientes/Klabin.png";
import Metalfrio from "../imagens/clientes/Metalfrio.png";
import VoltaGrande from "../imagens/clientes/VoltaGrande.png";
import Trox from "../imagens/clientes/Trox.png";
import Plastbel from "../imagens/clientes/Plastbel.png";
import Huh from "../imagens/clientes/Huh.png";
import Masisa from "../imagens/clientes/Masisa.jpg";
import LP from "../imagens/clientes/LP.jpg";
import Cargill from "../imagens/clientes/Cargill.jpg";
import Perfileve from "../imagens/clientes/Perfileve.jpg";
import Lamipack from "../imagens/clientes/Lamipack.jpg";
import Arauco from "../imagens/clientes/Arauco.png";
import Brazilian from "../imagens/clientes/Brazilian.jpg";
import Miraluz from "../imagens/clientes/Miraluz.png";
import Tetrapak from "../imagens/clientes/Tetrapak.jpg";
import Fischer from "../imagens/clientes/Fischer.jpg";
import Copo from "../imagens/clientes/Copo.jpg";
import Scheffer from "../imagens/clientes/Scheffer.jpg";
import PLM from "../imagens/clientes/PLM.jpg";
import Novozymes from "../imagens/clientes/Novozymes.jpg";
import Incopisa from "../imagens/clientes/Incopisa.jpg";
import Cocelpa from "../imagens/clientes/Cocelpa.jpg";
import Alltech from "../imagens/clientes/Alltech.jpg";
import Ibema from "../imagens/clientes/Ibema.png";
import Bunge from "../imagens/clientes/Bunge.png";
import Penha from "../imagens/clientes/Penha.png";
import Realce from "../imagens/clientes/Realce.png";
import { EnvelopeAt, Telephone, Whatsapp, CardHeading } from 'react-bootstrap-icons';
import ConversaoBotao from './Util/util.js';
import logoWhite from "../imagens/lgAman-white.png";

export default function Home() {

    const handleWhatsApp = () => {
        ConversaoBotao("https://api.whatsapp.com/send?phone=5542999720993&text=Gostaria%20de%20mais%20informações.",1,"google",1);
    }
    const handleTelefone = () => {
        ConversaoBotao('tel:+554232223648',0,'google',0);
    }
    const handleEmail = () => {
        window.location.href = "mailto:amanengenharia@amanengenharia.com.br";
    }

    return (
        <>
            <div className="imagem-principal">                
                <div className="conteudo">
                    <img src={imgTransparente} alt="Excelência em Consultoria e Assessoria de Manutenção Industrial" />
                    <div className="texto-imagem-principal">
                        <div className="frase">
                            <h1>Excelência em Consultoria e Assessoria de Manutenção Industrial</h1>
                            <div>
                                <p>
                                    <i>Há mais de uma década</i> oferecendo soluções para área de manutenção.
                                </p>
                                <ul>
                                    <li>Consultoria e Assessoria.</li>
                                    <li>Diagnóstico da Área de Manutenção.</li>
                                    <li>Treinamentos.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="texto-imagem-principal-2">
                <div className="conteudo">
                    <p>
                        Há mais de uma década oferecendo soluções para área de manutenção.
                    </p>
                    <br />
                    <ul>
                        <li>Consultoria e Assessoria.</li>
                        <li>Diagnóstico da Área de Manutenção.</li>
                        <li>Treinamentos.</li>
                    </ul>
                </div>
            </div>
            <div className="conteudo contatos" id="contatos">
                <Contato></Contato>
                <div className="telefones">
                    <h3 className="margin-top-0">Caso prefira, ligue ou chame no WhatsApp. <i>Será um prazer atendê-lo.</i></h3>
                    <ul className="links">
                        <li className="whatsapp" onClick={handleWhatsApp}><Whatsapp></Whatsapp> (42) 99972-0993</li>
                        <li className="telefone" onClick={handleTelefone}><Telephone></Telephone> (42) 3222-3648</li>
                        {/* <li className="email" onClick={handleEmail}><EnvelopeAt></EnvelopeAt> amanengenharia@amanengenharia.com.br</li> */}
                    </ul>
                    <br />
                    <br />
                    <div className="quem-somos">
                        <h1 className="margin-top-0">Quem somos</h1>
                        Somos especializados em consultoria e assessoria em manutenção industrial. Trabalhamos na implantação das melhores práticas de manutenção, buscando a otimização dos processos de gestão, engenharia de manutenção, planejamento e execução.
                        <h1>Missão</h1>
                        Prestar serviço de qualidade em consultoria e assessoria em manutenção com a finalidade de maximizar a disponibilidade e confiabilidade dos equipamentos de forma a proporcionar ao cliente um aumento de sua produtividade, qualidade e lucro.
                    </div>
                </div>
            </div>
            <div className="area-texto-fabrica imagem-fundo">
                <div className="conteudo">
                    <p className="texto-fabrica margin-top-0">
                        A metodologia da AMAN é focada em resultados. 
                        <br />Além de aplicar a estratégia de manutenção, trabalha fortemente o engajamento das pessoas.
                    </p>
                    <ul className="itens-metodologia">
                        <li className="item">
                            <div className="imagem-titulo consultoria"></div>
                            <h1>Consultoria</h1>
                            Otimize o processo de manutenção de sua empresa com a consultoria especializada da AMAN Engenharia de Manutenção.
                            <ul className="lista-padrao">
                                <li>Implantação de um sistema de manutenção robusto e eficiente.</li>
                                <li>Baseado nas melhores práticas de manutenção. Manutenção classe mundial.</li>
                                <li>Metodologia testada nos mais variados segmentos.</li>
                                <li>Engenheiros consultores com longa experiência e em constante aprimoramento.</li>
                            </ul>
                        </li>
                        <li className="item">
                            <div className="imagem-titulo diagnostico"></div>
                            <h1>Diagnóstico</h1>
                            Etapas da avaliação e diagnóstico:
                            <ul className="lista-padrao">
                                <li>Entendimento e avaliação do processo de manutenção da empresa.</li>
                                <li>Avaliação da documentação e registros da área de manutenção.</li>
                                <li>Verificação in loco do estado de manutenção dos equipamentos.</li>
                                <li>Compilação e análise das informações.</li>
                                <li>Elaboração do relatório de resultados.</li>
                                <li>Apresentação do diagnóstico.</li>
                            </ul>
                        </li>
                        <li className="item">
                            <div className="imagem-titulo treinamento"></div>
                            <h1>Treinamentos personalizados para atender sua necessidade</h1>
                            <p>
                                Profissionais precisam estar preparados e serem eficientes, investir na qualificação do pessoal é um grande diferencial competitivo.
                            </p>
                            <p>
                                Procuramos conhecer os objetivos do cliente em relação ao treinamento e elaboramos o curso de forma personalizada para atendimento de suas necessidades.
                            </p>
                        </li>
                    </ul>
                    <br />
                    <div className="botaoAcao-02" onClick={() => window.location.href="#contatos"}>QUERO ENTRAR EM CONTATO AGORA</div>
                </div>
            </div>
            <div className="area-texto-fabrica ramo-atuacao">
                <div className="conteudo">
                    <p className="texto-fabrica texto-ramo margin-top-0">
                       + de 15 anos no mercado 
                        <br />alcançando excelentes resultados.
                    </p>
                    <ul className="itens-metodologia">
                        <li className="item">
                            <p>
                                Cases com 
                                <br />alcance de 99,5%
                                <br />de disponibilidade
                            </p>
                        </li>
                        <li className="item">
                            <p>
                                Cases com
                                <br />diminuição de
                                <br />+ 90% das paradas
                            </p>
                        </li>
                        <li className="item">
                            <p>
                                Payback de
                                <br />curtíssimo prazo!
                            </p>
                        </li>
                    </ul>
                    <br />
                    <div className="botaoAcao-02" onClick={() => window.location.href="#contatos"}>QUERO ENTRAR EM CONTATO AGORA</div>
                </div>
            </div>
            <div className="area-texto-fabrica clientes">
                <div className="conteudo">
                    <h1 style={{margin:0}}>Nossos Clientes</h1>
                    <br />
                    <span className="anima-logos">
                        <ul className="itens-clientes">
                            <li className="item">
                                <img src={Randa} alt="Randa" />
                            </li>
                            <li className="item">
                                <img src={Klabin} alt="Klabin" />
                            </li>
                            <li className="item">
                                <img src={Metalfrio} alt="Metalfrio" />
                            </li>
                            <li className="item">
                                <img src={VoltaGrande} alt="VoltaGrande" />
                            </li>
                            <li className="item">
                                <img src={Trox} alt="Trox" />
                            </li>
                            <li className="item">
                                <img src={Plastbel} alt="Plastbel" />
                            </li>
                            <li className="item">
                                <img src={Huh} alt="Huh" />
                            </li>
                            <li className="item">
                                <img src={Masisa} alt="Masisa" />
                            </li>
                            <li className="item">
                                <img src={LP} alt="LP" />
                            </li>
                            <li className="item">
                                <img src={Cargill} alt="Cargill" />
                            </li>
                            <li className="item">
                                <img src={Perfileve} alt="Perfileve" />
                            </li>
                            <li className="item">
                                <img src={Lamipack} alt="Lamipack" />
                            </li>
                            <li className="item">
                                <img src={Arauco} alt="Arauco" />
                            </li>
                            <li className="item">
                                <img src={Brazilian} alt="Brazilian" />
                            </li>
                            <li className="item">
                                <img src={Miraluz} alt="Miraluz" />
                            </li>
                            <li className="item">
                                <img src={Tetrapak} alt="Tetrapak" />
                            </li>
                            <li className="item">
                                <img src={Fischer} alt="Fischer" />
                            </li>
                            <li className="item">
                                <img src={Copo} alt="Copo" />
                            </li>
                            <li className="item">
                                <img src={Scheffer} alt="Scheffer" />
                            </li>
                            <li className="item">
                                <img src={PLM} alt="PLM" />
                            </li>
                            <li className="item">
                                <img src={Novozymes} alt="Novozymes" />
                            </li>
                            <li className="item">
                                <img src={Incopisa} alt="Incopisa" />
                            </li>
                            <li className="item">
                                <img src={Cocelpa} alt="Cocelpa" />
                            </li>
                            <li className="item">
                                <img src={Alltech} alt="Alltech" />
                            </li>
                            <li className="item">
                                <img src={Ibema} alt="Ibema" />
                            </li>
                            <li className="item">
                                <img src={Bunge} alt="Bunge" />
                            </li>
                            <li className="item">
                                <img src={Penha} alt="Penha" />
                            </li>
                            <li className="item">
                                <img src={Realce} alt="Realce" />
                            </li>
                        </ul>
                    </span>
                </div>                    
            </div>
            <div className="area-texto-fabrica depoimentos">
                <div className="conteudo">
                    <h1 className="margin-top-0">Depoimentos</h1>
                    <ul>
                        <li>
                            <div>&ldquo;</div>
                            <span>
                                {/* A AMAN conta com alguns diferenciais que foram fundamentais para mudar nossa realidade: possui um sistema de gestão de manutenção muito robusto, baseado em princípios que , à primeira vista, podem parecer simples (e são!) mas que possuem uma sabedoria que vem apenas daqueles que tem experiência prática acumulada ao longo dos anos. Nada de modismos e aqueles jargões que mudam o nome e nunca a essência mas sim de ações muito bem pensadas e estruturadas de forma que uma complementa a outra e que funcionam perfeitamente em conjunto. O trabalho de assessoria é conduzido por profissional altamente qualificado e com muita vivência na área, o que traz segurança ao cliente e rapidez no processo de implantação do Sistema. */}
                                Nossos resultados através da implementação do Sistema AMAN de Gestão de Manutenção são fantásticos e inimagináveis antes de sua implementação. Num ambiente muito complexo em que nossas operações estão inseridas, contar com níveis de disponibilidade acima de 98% realmente ajuda muito nosso negócio. Definitivamente somos gratos à AMAN por mudar nossa realidade e, obviamente, recomendamos seus serviços para qualquer indústria.
                            </span>
                            <div style={{float:"right"}}>&rdquo;</div>
                            <p style={{display:"flex", alignItems:"center", gap:"10px"}}>
                                <img src={Metalfrio} style={{width:"100px"}} alt="Metalfrio" />
                                <b style={{color:"#2f2d5e"}}>Luís Fernando Contezini - Gerente Industrial / Metalfrio Solutions S.A., Três Lagoas–MS</b>
                            </p>
                        </li>
                        <li>
                            <div>&ldquo;</div>
                            <span>
                                O sistema de gestão da manutenção da AMAN adota uma metodologia simples e objetiva, que inclui treinamentos específicos para mecânicos, supervisores e gestores, além da implementação de rotinas claraspara cada nível organizacional. 
                                {/* <br /><br />O sistema também contempla relatórios de controle e levantamento deindicadores, assegurando uma gestão precisa e eficaz.Combinado com uma equipe comprometida, o sistema de gestão da AMAN gera resultados significativos já nocurto prazo (3 a 6 meses) e, a longo prazo, transforma a cultura da empresa de forma positiva, impactandotanto o nível operacional quanto o de gestão.Na nossa empresa, alcançamos consistência nos indicadores de manutenção, maior organização no setor,paradas programadas mais eficientes e clareza nas tarefas.  */}
                                O comprometimento da equipe de manutenção e dos operadores de máquinas também aumentou consideravelmente.
                                Agradecemos à AMAN por promoveressa transformação em nossa empresa.
                            </span>
                            <div style={{float:"right"}}>&rdquo;</div>
                            <p style={{display:"flex", alignItems:"center", gap:"10px"}}>
                                <img src={Miraluz} style={{width:"70px"}} alt="Metalfrio" />
                                <b style={{color:"#2f2d5e"}}>Lucas Godoy - Gerente de Produção / Miraluz, Sangés-PR</b>
                            </p>
                        </li>
                        <li>
                            <div>&ldquo;</div>
                            <span>
                                Com a Consultoria Aman na área de Manutenção, iniciamos um grande trabalho na Indústria com foco na disponibilidade dos equipamentos com a metodologia de Inspeção, planejamento e preventiva e com este objetivo grandes resultados foram alcançados.
                                A Consultoria Aman atua com indicadores para direcionar os esforços, treinamentos para os Manutentores, reuniões de apresentação de indicadores e resultados.
                            </span>
                            <div style={{float:"right"}}>&rdquo;</div>
                            <p style={{display:"flex", alignItems:"center", gap:"10px"}}>
                                <img src={Randa} style={{width:"100px"}} alt="Metalfrio" />
                                <b style={{color:"#2f2d5e"}}>Orlei Braz - Gerente Industrial / Randa Portas, Bituruna-PR</b>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="area-texto-fabrica rodape">
                <div className="conteudo">
                    <img src={logoWhite} alt="AMAN Engenharia" />
                    <br />&#169; 2025 AMAN Engenharia de Manutenção. Todos os direitos reservados.
                </div>
            </div>
        </>
    );
}